var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-device"},[_c('div',{staticClass:"content"},[(_vm.showIcon)?_c('icon-no-device',{staticClass:"icon",attrs:{"height":"70","width":"70","iconColor":"#8067B7"}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t("noPrimaryDevice"))+"\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }